<template>
  <div>
    <div class="grid grid-cols-4 gap-x-16 gap-y-10 rounded-2xl bg-beige-50 px-4 py-12 text-center md:p-16 lg:grid-cols-12">
      <slot />
    </div>
  </div>
</template>
